import React, { Component } from "react";
import "../../../DocPreview.css";
import { FONT_SIZE } from "../../../Constants/Constants";
import Utility, { getPageHeight, getVW } from "../../../Utilities/Utility";
import "../css/Templates.css";

export default class USCheckTemplate1 extends Component {

    totalHeight = 196.64
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
        };
    }

    componentWillReceiveProps(nextProp) {
        this.setState({
            data: nextProp.data,
        });
    }

    render() {
        return (
            <div className='DocumentHolder ColumnDiv' style={{  minHeight: getPageHeight()}}>
                <div className='parent-width' style={{ width: '100%'}}>
                    {this.renderCheque()}
                </div>
            </div>
        );
    }

    renderCheque() {
        if (this.state.data.lineItems === undefined || this.state.data.lineItems === null) {
            return undefined
        }

        if (this.state.data.lineItems.length === 0) {
            return undefined
        }

        var cheques = this.state.data.lineItems.map(element => {
            return this.renderChequeContainer(element)
        });

        return cheques
    }

    renderChequeContainer(element) {
        return <div className="break-inside-avoid" style={{ paddingTop: getVW(5), paddingBottom: getVW(45) }}>
            <div>
                <div style={{
                    height: getVW(75),
                }}>
                </div>
                {this.renderDateContainer(element)}
                <div style={{
                    height: getVW(30),
                }}>
                </div>
                {this.renderTopHeaderContainer(element)}
                <div style={{
                    height: getVW(17),
                }}>
                </div>
                {this.renderMiddleContainer(element)}
                <div style={{
                    height: getVW(60),
                }}>
                </div>
                {this.renderBottomContainer(element)}
                <div style={{
                    height: getVW(30),
                }}>
                </div>
            </div>
        </div>
    }

    renderDateContainer(element) {
        return <div className="RowReverseDiv">
            {this.renderTopHeaderDataColumn(element.date)}
        </div>
    }

    renderTopHeaderContainer(element) {
        return <div className="RowDiv">
            <div style={{
                width: '10%',
                paddingLeft: getVW(7.6)
            }}></div>
            <div style={{
                width: '70%',
                paddingLeft: getVW(7.6)
            }}>
                {this.renderTopHeaderDataColumn(element.payTo)}
            </div>
            <div style={{
                width: '20%',
                paddingRight: getVW(7.6)
            }}>
                {this.renderMiddleDataColumn(element.amount, undefined, 'RowReverseDiv')}
            </div>
        </div>
    }

    renderMiddleContainer(element) {
        return <div className="RowDiv"
            style={{
                alignItems: 'baseline',
                paddingLeft: getVW(8),
                paddingRight: getVW(8),
            }}>
            {this.renderMiddleDataColumn(element.amountInWords, { padding: getVW(7.6)})}
        </div>
    }

    renderBottomContainer(element) {
        return <div className="RowDiv"
            style={{
                alignItems: 'baseline',
                paddingLeft: getVW(40)
            }}>
            <div style={{
                width:'70%',
                height:'100%',
                alignSelf:'flex-end',
                textAlign: 'initial'
            }}
            >
            </div>
            <div style={{
                paddingLeft: getVW(10),
                width:'30%',
                ...this.defaultStyle(),
                }}
                //Note: Use in future // dangerouslySetInnerHTML={{ __html: element.signature }}
                >
            </div>
        </div>
    }

    renderTopHeaderTitleColumn(text) {
        return <div style={{
            fontWeight: 'bold',
            ...this.defaultStyle()
        }}>
            {text} &nbsp;
        </div>
    }

    renderTopHeaderDataColumn(text) {
        return <div style={{
            paddingLeft: getVW(8),
            paddingRight: getVW(8),
            ...this.defaultStyle()
        }}>
            {text} &nbsp;
        </div>
    }

    renderMiddleTitleColumn(text) {
        return <div style={{
            fontWeight: 'bold',
            paddingTop: getVW(7.6),
            paddingBottom: getVW(7.6),
            ...this.defaultStyle()
        }}>
            {text} &nbsp;
        </div>
    }

    renderMiddleDataColumn(text, additionalStyle, className) {
        return <div className={className} style={{
            ...additionalStyle,
            ...this.defaultStyle()
        }}>
            {text} &nbsp;
        </div>
    }



    defaultStyle() {
        return {
            fontFamily: 'calibri san-serif',
            lineHeight: '115%',
            textAlign: 'left',
            ...Utility.getFontStyleProp({fontSize: FONT_SIZE.medium})
        }
    }
}
